import React, { useState, useEffect } from "react";
import { inputFormat, inputCustomFormat, billPlease, moneyFormat } from "../../ultil";
import _ from "lodash";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import {
  AppBar,
  Box,
  Divider,
  Paper,
  Tab,
  Tabs,
  Typography,
  IconButton,
  Grid,
  Button,
  ButtonBase,
  ButtonGroup,
  Modal,
  Toolbar,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import {style} from '../../style';

const ListTopping = ({
  dataDetail,
  setDataDetail,
  setAddCart,
  addCart,
  setIsOpenListTopping,
  setIsOpenTopping,
  infoStore,
  index = 0,
  orderType,
  user,
  discountMoneyStore,
  isEditTopping,
  setIsEditTopping,
  indexEditTopping,
  setIndexEditTopping
}) => {
  const [count, setCount] = useState(0);

  const [checkCount, setCheckCount] = useState(0);

  const [toppingSelected, setToppingSelected] = useState([]);

  useEffect(() => {
    setCheckCount(1);
    setCount(1);
  }, []);

  const btnOff = () => {
    setDataDetail({});
    setCount(dataDetail.quantity);
    setIsOpenListTopping(false);
    document.body.style.overflow = "auto";
  };

  const renderNameTopping = data => {
    let toppings = [];
    data.map((item, i) => {
      item.toppingSelected.map((t, j) => {
        toppings.push(t.name);
      });
    });
    return toppings.join(", ");
  };

  const billTopping = dataDetail => {
    let sum = dataDetail.pricePromote;
    dataDetail.toppingSelected.map((item, i) => {
      item.toppingSelected.map((t, j) => {
        sum += t.price * t.quantity;
      });
    });
    return sum * dataDetail.quantity;
  };

  const editTopping = (data, idx) => {
    setIndexEditTopping(idx);
    setIsOpenListTopping(false);
    setIsEditTopping(true);
    setIsOpenTopping(true);
    setDataDetail(data);
    document.body.style.overflow = "auto";
  };

  const btnAddToCard = (data, idx) => {
    addCart[idx].quantity++;
    setAddCart(_.cloneDeep(addCart));
    localStorage.setItem("list-carts", JSON.stringify(addCart));
  };

  const removeFromCart = (data, idx) => {
    if (addCart[idx].quantity > 1) {
      addCart[idx].quantity--;
    } else {
      addCart.splice(idx, 1);
    }
    localStorage.setItem("list-carts", JSON.stringify(addCart));
    setAddCart(_.cloneDeep(addCart));
    if (!addCart.map(item=>item._id).includes(dataDetail._id)) {
      setIsOpenListTopping(false);
    }
  };

  const totalPriceTopping = () => {
    return addCart.filter(v=>v._id === dataDetail._id).map(v=>billTopping(v)).reduce((a,b)=>a+b,0)
  }
  return (<>
    <Box sx={style}>
    <Box sx={{position: 'relative', marginBottom: '64px'}}>
      <AppBar
        position="sticky"
        color="inherit"
      >
        <Toolbar sx={{minHeight: '52px'}}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={btnOff}
          >
            <ArrowBackIcon fontSize="large"/>
          </IconButton>
          <TextBody className="line-clamp-1" component="div">
            {dataDetail.name}
          </TextBody>
        </Toolbar>
      </AppBar>
      <Box mt={1} p={2} bgcolor="#ffffff">
      {
        addCart ?
        addCart.map((item, i)=>{
          if (item._id === dataDetail._id) {
            return <Box key={i}>
              <CartToppingItem
                toppings={renderNameTopping(item.topping)}
                onClickEdit={() => editTopping(item, i)}
                onClickAdd={() => btnAddToCard(item, i)}
                onClickMinus={() => removeFromCart(item, i)}
                price={billTopping(item)}
                quantity={item.quantity}
              />
              <Divider/>
            </Box>
          } else {
            return null
          }
        })
        :null
      }
      <Box sx={{display: 'flex'}} my={1}>
        <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}><strong>Tổng: </strong></TextBody2>
        <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}><strong>{moneyFormat(totalPriceTopping())}</strong></TextBody2>
      </Box>
      </Box>
      <Box sx={{position: 'fixed', maxWidth:'600px', width: '100%', bottom: 0, display: 'flex', bgcolor: '#ffffff', padding: '12px 16px', zIndex: 1}}>
        <ButtonGroup onClick={() => {
          setIsOpenListTopping(false);
          setIsOpenTopping(true);
        }} sx={{flexGrow: 1}} size="small" variant="text" aria-label="text button group">
          <Button fullWidth variant="contained" sx={{borderRadius: '16px', fontSize: '16px', bgcolor: '#1589D8'}}>Thêm mới</Button>
        </ButtonGroup>
      </Box>
    </Box>
    </Box>
  </>);
};
export default ListTopping;

const CartToppingItem = ({toppings, price=0, quantity=0, onClickEdit=()=>{}, onClickAdd=()=>{}, onClickMinus=()=>{}}) => {
  return <Box my={1}>
    <TextBody2 color component="div">
      <span style={{color: '#929394'}}>TOPPING:</span> {toppings}
    </TextBody2>
    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'end'}}>
      <TextBody2 py={1} component="div">
        {moneyFormat(price)}
      </TextBody2>
      <Box sx={{display: 'flex'}}>
        <IconButton onClick={onClickEdit} sx={{color: '#1589D8'}}>
          <BorderColorIcon/> Thay đổi
        </IconButton>
        <ButtonGroup size="small" variant="text" aria-label="text button group">
          <IconButton onClick={onClickMinus}><i className="icon-minus-square" style={{fontSize: '24px', color: '#b0bec5'}}/></IconButton>
          <IconButton><TextQuantity component="span">{quantity}</TextQuantity></IconButton>
          <IconButton onClick={onClickAdd}><i className="icon-add-square" style={{fontSize: '24px', color: '#1589D8'}}/></IconButton>
        </ButtonGroup>
      </Box>
    </Box>
  </Box>;
}
